import React from 'react';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import { SelectPersonsInAccidentField } from 'modules/components/layer04';

import * as ds from './dataService';
import { Stack } from '@mui/material';
import { SaveIncident_Input } from 'generated/graphql';
import { DateTime } from 'luxon';

export type SaveIncidentFormProps = {
  id: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: SaveIncidentFormProps) => {
  const [
    fnSaveForm,
    { loading }
  ] = ds.useSaveIncidentForm();
  const form = ds.useFormState(props.id, props.projectId);
  const handleSubmit = async (input: ds.IFormState) => {
    const tempInput: SaveIncident_Input = {
      id: input.id,
      projectId: input.projectId,
      description: input.description,
      issueDate: DateTime.fromFormat(input.issueDate, 'yyyy-LL-dd'),
      personsInvolvedIds: input.personsInvolvedIds
    };
    await fnSaveForm(tempInput);
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
        props.handleClose();
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      {/* ADD FIELDS */}
      <Stack
        rowGap='1.5rem'
      >
        <StyledTextField.FC
          {...form.genFieldProps('issueDate')}
        />
        <StyledTextField.FC
          {...form.genFieldProps('description')}
          minRows={4}
        />
        <SelectPersonsInAccidentField.FC
          form={form}
          fieldName='personsInvolvedIds'
        />
      </Stack>
    </FormBaseLayout.FC>

  );
};
